var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * LoginBoundary Component.
 * Author: @tejasupmanyu
 */
import * as React from 'react';
import { eventEmitter } from './loginExpiry';
import LoginExpiryModal from './LoginExpiryModal/loginExpiryModal';
var LoginBoundary = /** @class */ (function (_super) {
    __extends(LoginBoundary, _super);
    function LoginBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.showListener = null;
        _this.hideListener = null;
        _this.showLoginExpiryModal = function (params) {
            _this.setState(__assign({ visible: true }, (params ? params : {})));
        };
        _this.hideLoginExpiryModal = function () {
            _this.setState({
                visible: false,
            });
        };
        _this.state = {
            visible: false,
            params: {},
        };
        return _this;
    }
    LoginBoundary.prototype.componentDidMount = function () {
        this.showListener = eventEmitter.addListener('showLoginExpiry', this.showLoginExpiryModal);
        this.hideListener = eventEmitter.addListener('hideLoginExpiry', this.hideLoginExpiryModal);
    };
    LoginBoundary.prototype.componentWillUnmount = function () {
        this.showListener && this.showListener.remove();
        this.hideListener && this.hideListener.remove();
    };
    LoginBoundary.prototype.render = function () {
        var _a = this.state, visible = _a.visible, params = _a.params;
        return (React.createElement(React.Fragment, null,
            this.props.children,
            React.createElement(LoginExpiryModal, { visible: visible, hideModal: this.hideLoginExpiryModal, params: params })));
    };
    return LoginBoundary;
}(React.Component));
export default LoginBoundary;
//# sourceMappingURL=loginBoundary.js.map